// Entry point for the submission-flow API. All flow code calls
// getSubmissionFlowApi() — never an implementation directly — so mock vs
// real stays a single-seam decision (REACT_APP_USE_MOCK_API / ?mock=1).

import { isMockApi } from "./config";
import mockSubmissionFlowApi from "./SubmissionFlowApi.mock";
import realSubmissionFlowApi from "./SubmissionFlowApi.real";
import { withErrorReporting } from "./errorReporting";
import { ISubmissionFlowApi } from "./types";

export * from "./types";
export {
  getForcedCountryCode,
  getMockLatencyMs,
  getMockScenario,
  isMockApi,
  MOCK_SCENARIOS,
} from "./config";
export { MOCK_IDS } from "./fixtures";

let instance: ISubmissionFlowApi | null = null;

export const getSubmissionFlowApi = (): ISubmissionFlowApi => {
  if (!instance) {
    // The real API reports its failures to Sentry; the mock's are on purpose.
    instance = isMockApi() ? mockSubmissionFlowApi : withErrorReporting(realSubmissionFlowApi);
    // eslint-disable-next-line no-console
    console.info(
      `[submission-flow] API mode: ${instance === mockSubmissionFlowApi ? "MOCK" : "REAL"}`
    );
  }
  return instance;
};

// Test seam: lets unit tests flip mode between cases without reloading.
export const resetSubmissionFlowApiForTests = () => {
  instance = null;
};
